import BasicButton from "../../common/components/BasicButton";

interface BulkActionsProps {
  selectedCount: number;
  onSchedulePublish: () => void;
  onDelete: () => void;
  isLoading?: boolean;
}

export default function OriginalPostBulkActions({
  selectedCount,
  onSchedulePublish,
  onDelete,
  isLoading,
}: BulkActionsProps) {
  if (selectedCount === 0) {
    return null;
  }

  return (
    <div className="flex items-center justify-between rounded-lg bg-gray-50 p-4">
      <span className="text-sm text-gray-600">
        {selectedCount}개의 항목이 선택되었습니다.
      </span>
      
      <div className="flex gap-2">
        <BasicButton
          text={isLoading ? "처리 중..." : "발행예정 처리"}
          onClick={onSchedulePublish}
          disabled={isLoading}
          className={`${isLoading ? 'bg-blue-300' : 'bg-blue-500 hover:bg-blue-600'} text-white`}
        />
        
        <BasicButton
          text="삭제"
          onClick={onDelete}
          variant="error"
        />
      </div>
    </div>
  );
}